import React from 'react';
import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Radio,
  RadioGroup,
  FormControl, CardActions, CardHeader
} from '@mui/material';

const notificationTitle = "Email Type";
const notificationsSubTitle = "What type of email do you want to receive?";

export const AccountProfileDetails = (props) => {
  const user = props.user;
  const setMessage = props.setMessage;
  const setSeverity = props.setSeverity;
  const [values, setValues] = React.useState(null);
  const [edited, setEdited] = React.useState(false);
  const setIsUser = props.setIsUser;
  const setFooterSelection = props.setFooterSelection;

  React.useEffect(() => {
    setIsUser(true);
    setFooterSelection(0);
  }, [])

  React.useEffect(() => {
    if (null != user) {
      setValues(user);
    }
  }, [user])

  const handleChange = (event) => {
    setEdited(true);
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleCheckboxChange = (event) => {
    setEdited(true);
    setValues({
      ...values,
      [event.target.name]: event.target.checked
    });
  }

  const submit = async (values) => {
    try {
      const res = await fetch(process.env.REACT_APP_API_HOST + '/account/update', {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Authorization': 'Basic ' + btoa('deirdreh@gmail.com:gingercat'),
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      }).catch((error) => {
        setMessage("User Update Failed");
        setSeverity("warning");
      })
      if (!res.ok) {
        throw new Error(await res.json());
      } else {
        return res.json().then(res => {
          if (res.success) {
            setMessage("User Updated");
            setSeverity("success");
            setEdited(false);
          } else {
            setMessage("User Update Failed");
            setSeverity("warning");
          }
        })
      }
    } catch (ex) {
      setMessage("User Update Failed");
      setSeverity("warning");
    }
  }

  const cancel = () => {
    setValues(user);
    setEdited(false);
  }


  if (null !== values) {
    return (
      <>

        <form
          autoComplete="off"
          noValidate
        >
          <Card>
            <CardHeader
              title="User Details"
            />
            <CardContent>
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Name"
                    name="name"
                    onChange={handleChange}
                    required
                    value={values.name}
                    variant="outlined"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <TextField
                    fullWidth
                    label="Email Address (Username)"
                    name="username"
                    onChange={handleChange}
                    required
                    value={values.username}
                    variant="outlined"
                  />
                  <Typography
                    component="div"
                    variant="subtitle2"
                    sx={{ marginTop: 1 }}
                  > NOTE: Changing your primary email address will change your login username</Typography>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <FormControlLabel
                    control={(
                      <Checkbox
                        name="primary"
                        color="primary"
                        checked={values.primary}
                        onChange={handleCheckboxChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    )}
                    label="Use Primary Email"
                  /><br />
                  <FormControlLabel
                    control={(
                      <Checkbox
                        name="profile"
                        color="primary"
                        checked={values.profile}
                        onChange={handleCheckboxChange}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                    )}
                    label="Use Profile Email"
                  /><br />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid
                container
                spacing={1}
              >
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <Typography
                    color="textPrimary"
                    variant="h6"
                  >
                    {notificationTitle}
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="subtitle"
                  >
                    {notificationsSubTitle}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={12}
                  xs={12}
                >
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="html"
                      value={values.contentType}
                      name="contentType"
                      onChange={handleChange}
                    >
                      <FormControlLabel value="text/html" control={<Radio />} label="HTML" />
                      <FormControlLabel value="text/plain" control={<Radio />} label="Text" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ m: 1 }}>
              <Button
                color="primary"
                variant="contained"
                disabled={!edited}
                onClick={() => submit(values)}>Save
              </Button>
              <Button
                color="secondary"
                variant="contained"
                disabled={!edited}
                onClick={() => cancel()}>Cancel
              </Button>
            </CardActions>
          </Card>
        </form >
      </>
    );
  } else { return null; }
};
